import { JSX } from "react";
import { TertiaryTable } from "@hatch-digital-nl/abs-storybook/legacy";
import { mapUnachievedEmployeeDataToRows } from "../../utils/mapUnachievedEmployeeDataToRows";
import { EmployeeInterface } from "../../../../common/interfaces/EmployeeInterface";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { QualificationInterface } from "../../../../common/interfaces/QualificationInterface";
import { QualificationDetailSortEnum } from "../../../../common/enums/QualificationDetailSortEnum";
import { Dispatch } from "redux";
import { handleEmployeeSort } from "../../utils/handleEmployeeSort";
import Skeleton from "react-loading-skeleton";
import { MetaInterface } from "../../../../common/interfaces/MetaInterface";

interface Props {
    employeeData?: {
        data?: EmployeeInterface[];
        meta?: MetaInterface;
    };
    employeeDataIsLoading: boolean;
    employeeDataIsFetching: boolean;
    qualificationData?: QualificationInterface;
    sortEmployees?: {
        sortName: string;
        isSorted: boolean;
    };
    dispatch?: Dispatch;
}
export const UnachievedEmployees = (props: Props): JSX.Element => {
    const {
        employeeData,
        employeeDataIsLoading,
        employeeDataIsFetching,
        qualificationData,
    } = props;

    const dispatch = useAppDispatch();

    const { sortEmployees } = useAppSelector(
        (state) => state.qualificationDetail,
    );

    if (
        !employeeData ||
        !qualificationData ||
        employeeDataIsLoading ||
        employeeDataIsFetching
    ) {
        return <Skeleton count={6} height={"5rem"} borderRadius={"0.8rem"} />;
    }

    return (
        <TertiaryTable
            data={{
                columns: [
                    {
                        value: "Naam",
                        isSortable: true,
                        isSorted:
                            sortEmployees.sortName ===
                            QualificationDetailSortEnum.EMPLOYEE_NAME_DESC,
                        sortOnClick: handleEmployeeSort({
                            sortEmployees: {
                                isSorted:
                                    sortEmployees.sortName ===
                                    QualificationDetailSortEnum.EMPLOYEE_NAME_DESC,
                                sortName:
                                    QualificationDetailSortEnum.EMPLOYEE_NAME,
                            },
                            dispatch,
                        }),
                    },
                    {
                        value: "Functie",
                    },
                ],
                rows: mapUnachievedEmployeeDataToRows(
                    dispatch,
                    qualificationData,
                    {
                        employeeData: employeeData?.data || [],
                    },
                ),
                total: employeeData.meta?.total || 0,
            }}
            title={`Nog niet behaald (${employeeData.meta?.total || 0})`}
            isBackgroundTransparent={true}
        />
    );
};
